import { createSlice } from '@reduxjs/toolkit';
import { getTopContent } from '@/services/topContentService';
import { logoutUser } from '@/store/slices/authSlice';
import { TopContentParams, TopContentResponse } from '@/types/topContent.types';
import {
  DataStateWithParams,
  createDataAsyncThunk,
  addDataAsyncCasesWithParams,
} from '@/store/utils/asyncThunkHelpers';

interface TopContentState {
  topContent: DataStateWithParams<TopContentResponse, TopContentParams>;
}

const initialState: TopContentState = {
  topContent: { data: null, status: 'idle', error: null },
};

export const fetchTopContent = createDataAsyncThunk<TopContentResponse, TopContentParams>(
  'topContent/fetchTopContent',
  getTopContent
);

const topContentSlice = createSlice({
  name: 'topContent',
  initialState,
  reducers: {},
  extraReducers: builder => {
    addDataAsyncCasesWithParams(builder, fetchTopContent, state => state.topContent);

    builder.addCase(logoutUser.fulfilled, () => {
      return initialState;
    });
  },
});

export default topContentSlice.reducer;
